module.exports = __webpack_public_path__ + "img/heart-fill.c33440a3.svg";